<template>
    <v-select 
       :value="selected_calculationcode"
       v-bind:items="calculationcodes"
       item-value="calculationcode" 
       item-text="calculationcodename" 
       :label="label"
       dense :clearable="selection_clearable"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_calculationcode: String,
        label: String,
        field: {
            default: 'calculationcode',
            required: true,
        },
        selection_clearable:{
            type: Boolean,
            default: false
        } 
    },
    data() {
        return {
            calculationcodes: [],
            codedescription: '',
            codename: ''
        }
    },
    created() {
        this.calculationcodes = this.getCalculationMethods().info;
    },
    async mounted () {
        this.codedescription = await this.setDescription(this.selected_calculationcode);
        this.codename = await this.setCodeName(this.selected_calculationcode);
        this.updateData(this.selected_calculationcode)
    }, 
    watch:{
        selected_calculationcode: {            
            async handler (){
                this.codedescription = await this.setDescription(this.selected_calculationcode);
                this.codename = await this.setCodeName(this.selected_calculationcode);
                this.$emit('updateData', [
                    {field: this.field, value: this.selected_calculationcode === null ? '' : this.selected_calculationcode}, 
                    {field: 'calculation_explanation', value: this.codedescription},
                    {field: 'calculation_name', value: this.codename}
                ])
            } 
        },
    },        
    methods: {
        getCalculationMethods(){
            return {
                info: 
                [
                    {
                        calculationcode: "rent",
                        calculationcodename: "Rent",
                        calculationcode_description: "Commission calculated over rent amount"
                    },
                    {
                        calculationcode: "rentcost",
                        calculationcodename: "Rent and costs",
                        calculationcode_description: "Commission calculated over rent amount incl. additional costs, excl. tourist tax"
                    }
                ]
            }
        },        
        async setDescription(){
            let desc = ''
            this.calculationcodes.forEach(x => {
                if (x.calculationcode === this.selected_calculationcode) {
                    desc = x.calculationcode_description;
                }       
            })
            return desc
        },   
        async setCodeName(){
            let desc = ''
            this.calculationcodes.forEach(x => {
                if (x.calculationcode === this.selected_calculationcode) {
                    desc = x.calculationcodename;
                }       
            })
            return desc
        },                
        async updateData(data){
            this.$emit('updateData', [
                {field: this.field, value: data === null ? '' : data }, 
                {field: 'calculation_explanation', value: this.codedescription},
                {field: 'calculation_name', value: this.codename}
            ])
        }
    }
}
</script>